var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7832 15.7837C14.3587 16.8695 12.6241 17.4711 10.8332 17.5003C4.99984 17.5003 1.6665 10.8337 1.6665 10.8337C2.70308 8.90193 4.14078 7.21419 5.88317 5.88368M9.08317 4.36701C9.65678 4.23275 10.2441 4.16563 10.8332 4.16701C16.6665 4.16701 19.9998 10.8337 19.9998 10.8337C19.494 11.78 18.8907 12.671 18.1998 13.492M12.5998 12.6003C12.371 12.846 12.095 13.043 11.7883 13.1796C11.4816 13.3163 11.1506 13.3897 10.8149 13.3957C10.4792 13.4016 10.1458 13.3398 9.83451 13.2141C9.52322 13.0884 9.24044 12.9012 9.00304 12.6638C8.76565 12.4264 8.5785 12.1436 8.45276 11.8323C8.32702 11.521 8.26528 11.1876 8.2712 10.8519C8.27712 10.5163 8.35059 10.1852 8.48723 9.87855C8.62387 9.57189 8.82088 9.29589 9.0665 9.06701",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 1.66699L19.9998 20.0003",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/HidePassword.8ba479c6d1d42425feb4c74854afd8e5.svg";
export { ForwardRef as ReactComponent };